import { gql } from '@apollo/client';
import TaskListSectionsFragment from 'components/projects/taskList/gql/fragments/TaskListSectionsFragment.graphql';

const GET_TASK_LIST_POLLING = gql`
  query GetTaskListsPoll($id: ID!) {
    viewer {
      __typename
      id
      taskList(id: $id) {
        id
        isPopulating
      }
    }
  }
`;

const GET_TASK_LIST_HEADER = gql`
  query GetTaskListHeader($id: ID!) {
    viewer {
      __typename
      id
      taskList(id: $id) {
        __typename
        id
        uuid
        name
        category
        tasksCount
        tasksCompletedCount
        tasksSkippedCount
        updatedAt
        isPopulating
        lastActiveTask {
          id
          title
          completedBy {
            id
            name
          }
        }
        assignedUsers {
          nodes {
            id
            name
            avatar
            initials
          }
        }
        creator {
          id
        }
      }
    }
  }
`;

const GET_TASK_LIST_SECTIONS = gql`
  query GetTaskListSections($id: ID!, $first: Int, $after: String) {
    viewer {
      __typename
      id
      taskList(id: $id) {
        __typename
        ...TaskListSectionsFragment
      }
    }
  }
  ${TaskListSectionsFragment}
`;

export { GET_TASK_LIST_HEADER, GET_TASK_LIST_SECTIONS };

export default GET_TASK_LIST_POLLING;
